import newsImg from '@/assets/card/newsImg';

import Card from './Card';

const NewsCard = ({ cardId, width, height }) => {
	return (
		<Card
			cardId={cardId}
			width={width}
			height={height}
			cardImageArray={newsImg}
		/>
	);
};

export default NewsCard;
